export type RoleJobTitleDisplayMode = "strict" | "permissive";

export type RoleJobTitleDisplayInput = {
	roleValue: string | null | undefined;
	jobTitleValue: string | null | undefined;
	canViewRole: boolean;
	canViewJobTitle: boolean;
	mode?: RoleJobTitleDisplayMode;
};

export type RoleJobTitleDisplayResult =
	| { kind: "role"; value: string }
	| { kind: "jobTitle"; value: string }
	| { kind: "none"; value: null };

const NONE: RoleJobTitleDisplayResult = { kind: "none", value: null };

const isNonEmpty = (v: string | null | undefined): v is string => typeof v === "string" && v.length > 0;

export const getRoleOrJobTitleDisplay = ({
	roleValue,
	jobTitleValue,
	canViewRole,
	canViewJobTitle,
	mode = "permissive",
}: RoleJobTitleDisplayInput): RoleJobTitleDisplayResult => {
	if (canViewRole && isNonEmpty(roleValue)) {
		return { kind: "role", value: roleValue };
	}

	const fallbackAllowed = mode === "permissive" || canViewRole;
	if (fallbackAllowed && canViewJobTitle && isNonEmpty(jobTitleValue)) {
		return { kind: "jobTitle", value: jobTitleValue };
	}

	return NONE;
};
